import { useEntraRoles } from '@celito.clients/hooks';
import { isPlatformAdministrationHost } from '@celito.clients/utils';
import { Spinner } from '@fluentui/react-components';
import { Outlet } from 'react-router';

import NotInvitedScreen from '../../../not-authenticated/not-authenticated.screen';

export const TenantManagementAccess = () => {
  const { account, isSuperAdmin } = useEntraRoles();
  if (!isPlatformAdministrationHost()) {
    return <NotInvitedScreen />;
  }

  if (!account) {
    return <Spinner label="Checking access" />;
  }

  if (!isSuperAdmin) {
    return <NotInvitedScreen />;
  }

  return <Outlet />;
};
